<template>
  <div>
    <filters @change="loadSessionData" v-model="filter">
      <template slot-scope="{ query }">
        <date-filter label="Von" v-model="query['filter[after]']"></date-filter>
        <date-filter
          label="Bis"
          v-model="query['filter[before]']"
        ></date-filter>
        <checkbox-array-filter
          v-model="query['filter[role]']"
          :options="roleOptions"
        ></checkbox-array-filter>
      </template>
    </filters>
    <div class="row">
      <div class="col-12">
        <chart-card
          :chart-data="browserChart"
          :chart-options="browserChart.options"
          :chart-height="200"
          :loading="loading"
          chart-type="Pie"
        >
          <template slot="header">
            <h2 class="card-title">Browser</h2>
          </template>
          <template slot="footer">
            <div></div>
          </template>
        </chart-card>
      </div>
      <div class="col-12">
        <chart-card
          :chart-data="platformChart"
          :chart-options="platformChart.options"
          :chart-height="200"
          :loading="loading"
          chart-type="Pie"
        >
          <template slot="header">
            <h2 class="card-title">Betriebssysteme</h2>
          </template>
          <template slot="footer">
            <div></div>
          </template>
        </chart-card>
      </div>
      <div class="col-12">
        <chart-card
          :chart-data="resolutionChart"
          :chart-options="resolutionChart.options"
          :chart-height="200"
          :loading="loading"
          chart-type="Pie"
        >
          <template slot="header">
            <h2 class="card-title">Bildschirmauflösungen</h2>
          </template>
          <template slot="footer">
            <div></div>
          </template>
        </chart-card>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import ChartCard from "src/components/UIComponents/Cards/ChartCard";
import Filters from "src/components/SpatieFilter";
import DateFilter from "src/components/SpatieFilter/DateFilter";
import CheckboxArrayFilter from "src/components/SpatieFilter/CheckboxArrayFilter";

export default {
  components: {
    ChartCard,
    Filters,
    DateFilter,
    CheckboxArrayFilter,
  },
  created() {
    this.loadRoles();
  },
  data() {
    return {
      filter: {},
      roles: [],
      browsersCount: 0,
      platformsCount: 0,
      resolutionsCount: 0,
      browsers: null,
      platforms: null,
      resolutions: null,
      platformChart:{
        platformsCount: 0,
        labels: [],
        datasets: [],
        options: {
          legend: {
            display: true
          },
          cutoutPercentage: 50,
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                const formatter = new Intl.NumberFormat('de-DE', {});

                return tooltipItem.yLabel + ' ' + data.labels[tooltipItem.index] +
                  ': ' + formatter.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) +
                  ' ( ' + (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                  / this.platformsCount
                                  * 100
                          ).toFixed(2) +
                  ' % )';
              }
            }
          }
        }
      },
      resolutionChart: {
        resolutionsCount: 0,
        labels: [],
        datasets: [],
        options: {
          legend: {
            display: true
          },
          cutoutPercentage: 50,
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                const formatter = new Intl.NumberFormat('de-DE', {});

                return tooltipItem.yLabel + ' ' + data.labels[tooltipItem.index] +
                  ': ' + formatter.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) +
                  ' ( ' + (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                  / this.resolutionsCount
                                  * 100
                          ).toFixed(2) +
                  ' % )';
              }
            }
          }
        }
      },
      browserChart: {
        browsersCount: 0,
        labels: [],
        datasets: [],
        options: {
          legend: {
            display: true
          },
          cutoutPercentage: 50,
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                const formatter = new Intl.NumberFormat('de-DE', {});

                return tooltipItem.yLabel + ' ' + data.labels[tooltipItem.index] +
                  ': ' + formatter.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) +
                  ' ( ' + (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                  / this.browsersCount
                                  * 100
                          ).toFixed(2) +
                  ' % )';
              }
            }
          }
        }
      },
      loading: true,
    }
  },
  methods: {
    loadRoles() {
      return this.$http.get("/api/v1/roles")
        .then(({ data }) => {
          this.roles = data;
        });
    },
    loadSessionData() {
      this.loading = true;
      return this.$http.get("/api/v1/userSession/statisticData", {
        params: this.filter
      })
      .then(({ data }) => {
        this.browsers = data.browser;
        this.platforms = data.platform;
        this.resolutions = data.resolution;

        this.fillBrowserChart();
        this.fillPlatformChart();
        this.fillResolutionChart();
      })
        .then(() => this.loading = false);
    },
    fillBrowserChart() {
      this.browsersCount = 0;
      this.browserChart = Object.assign({}, this.browsers);

      let labels = [];
      let dataset = {
          label: "Browser",
          pointRadius: 0,
          pointHoverRadius: 0,
          backgroundColor: ["#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2",
                            "#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55",
                            "#e28956", "#e2cf55", "#c2e02c", "#4acccd", "#e02c2c",
                            "#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2",
                            "#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55",
                            "#e28956", "#e2cf55", "#c2e02c", "#4acccd", "#e02c2c"],
          borderWidth: 0,
          data: []
      };

      for (const [key, value] of Object.entries(this.browsers)) {
        this.browsersCount += parseInt(value, 10);
        labels.push(key);
        dataset.data.push(value);
      }

      this.browserChart.labels = labels;
      this.browserChart.datasets = [dataset];
    },
    fillPlatformChart() {
      this.platformsCount = 0;
      this.platformChart = Object.assign({}, this.platforms);

      let labels = [];
      let dataset = {
          label: "Betriebssysteme",
          pointRadius: 0,
          pointHoverRadius: 0,
          backgroundColor: ["#e28956", "#e2cf55", "#c2e02c", "#4acccd", "#e02c2c",
                            "#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55",
                            "#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2",
                            "#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2",
                            "#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55",
                            "#e28956", "#e2cf55", "#c2e02c", "#4acccd", "#e02c2c"],
          borderWidth: 0,
          data: []
      };

      for (const [key, value] of Object.entries(this.platforms)) {
        this.platformsCount += parseInt(value, 10);
        labels.push(key);
        dataset.data.push(value);
      }

      this.platformChart.labels = labels;
      this.platformChart.datasets = [dataset];
    },
    fillResolutionChart() {
      this.resolutionsCount = 0;
      this.resolutionChart = Object.assign({}, this.resolutions);

      let labels = [];
      let dataset = {
          label: "Bildschirmauflösungen",
          pointRadius: 0,
          pointHoverRadius: 0,
          backgroundColor: ["#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55",
                            "#e28956", "#e2cf55", "#c2e02c", "#4acccd", "#e02c2c",
                            "#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55",
                            "#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2",
                            "#e28956", "#e2cf55", "#c2e02c", "#4acccd", "#e02c2c",
                            "#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2"],
          borderWidth: 0,
          data: []
      };

      for (const [key, value] of Object.entries(this.resolutions)) {
        this.resolutionsCount += parseInt(value, 10);
        labels.push(key);
        dataset.data.push(value);
      }

      this.resolutionChart.labels = labels;
      this.resolutionChart.datasets = [dataset];
    }
  },
  computed: {
    roleOptions() {
      return this.roles.map((role) => ({
        text: role.name, value: role.name
      }));
    }
  }
};
</script>
